import AddStatement from './component'
export default AddStatement
